import * as Sentry from '@sentry/react'
import store from 'main/store'
import { fetcher } from 'services/helpers/responseHandler'
import { sessionExpiredHandler } from 'services/helpers/sessionExpiredHandler'
import LocalUserService from 'services/localUserService'

export function checkIfSessionExists() {
  const isSessionTimedOut = store.getState().login.sessionTimedOut
  const isSessionExpired = store.getState().login.sessionExpired

  if (isSessionExpired || isSessionTimedOut) {
    console.warn('cancelled request, no session')
  }
}

export function handleUnsuccesfulResponse(data, url) {
  if (data?.isSuccess) {
    return
  }

  if (data?.message?.startsWith('SessionTimedOut')) {
    sessionExpiredHandler()
    console.warn('session expired')
  } else if (data.message?.startsWith('UnAuthorized')) {
    const userService = new LocalUserService()
    const currentUserInfo = userService.getCurrentUserInfo()

    const uiDashboardSessionId = currentUserInfo?.sessionId
    const uiUserName = currentUserInfo?.user?.name
    const uiSubsidiaryName = store.getState().hotelDetails.name
    const uiSubsidiaryId = store.getState().login.currentHotelId
    const uiPath = document.location.pathname

    try {
      fetcher.post('logs', {
        level: 'Warn',
        message: `${uiUserName} got UnAuthorized on endpoint ${url}`,
        additionalData: {
          uiDashboardSessionId,
          uiUserName,
          uiSubsidiaryName,
          uiSubsidiaryId,
          uiPath
        }
      })
    } catch (error) {
      console.warn('failed to post log', error)
    }

    userNotAuthorizedHandler()
  } else {
    Sentry.captureMessage(`${data?.message} from ${url}`)
    throw new Error(`${data?.message} from ${url}`)
  }
}

export const userNotAuthorizedHandler = async () =>
  store.dispatch({ type: 'SET_USER_NOT_AUTHORIZED' })

export const userAuthorizedHandler = async () => {
  if (store.getState().login.userNotAuthorized) {
    store.dispatch({ type: 'SET_USER_AUTHORIZED' })
  }
}
